import { PlannedTransactionKind } from '@/features/dashboard/plannedTransactions/types/PlannedTransactionKind.ts';

/** Nazwa pozycji dopisywanej do harmonogramu przez paczkę zmian. */
export const plannedTransactionKindLabels: Record<
  PlannedTransactionKind,
  string
> = {
  [PlannedTransactionKind.INSTALLMENT]: 'Rata',
  [PlannedTransactionKind.CORRECTION]: 'Korekta zmiany',
  [PlannedTransactionKind.REFUND]: 'Zwrot (zmiana rezerwacji)',
};

export const getPlannedTransactionKindLabel = (
  kind: PlannedTransactionKind,
): string => plannedTransactionKindLabels[kind];
